"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.customModel.exceeded': 'Osiągnięto limit niestandardowych modeli AI. Ulepsz swój plan, aby trenować więcej modeli.',
    'limits.customModel.limitReached': 'Limit niestandardowego modelu: {limit} (ulepsz dla więcej)',
};
